// extracted by mini-css-extract-plugin
export default {"mainBody":"Popup_Vitrina_mainBody__6ZD9g","popupBack":"Popup_Vitrina_popupBack__jP1DL","popupBody":"Popup_Vitrina_popupBody__aEt26","dspNone":"Popup_Vitrina_dspNone__EffmT"};